<div class="card card-statistics mb-30">
  <div class="card-body">
      <h5 class="card-title">Add Letter Text</h5>
      <form [formGroup]="AddNewTextletter" (submit)="SubmitAddNewTextletter()">

        <input type="hidden" formControlName="id" />

        <div class="row">
          <div class="form-group col-md-6">
            <label for="exampleInputEmail1"> Letter Subject</label>
            <select class="custom-select" formControlName="Subject_id" >
              <option value="0">Select</option>
              <option *ngFor="let item of DataList_SubjectLetter" [value]="item.id">{{item.title}}</option>
            </select>
          </div>
          <div class="form-group col-md-6">
            <label for="exampleInputEmail1">Text</label>
            <input formControlName="Dsc" type="text" class="form-control"  placeholder="Type here...">
            <small *ngIf="!get_Form_Dsc().valid && get_Form_Dsc().touched" class="form-text text-muted MyErrorRedColor">Enter the text.</small>
          </div>
        </div>
        <div class="row">
          <div class="form-group col-md-6">
            <label for="exampleInputEmail1">Signatory Position</label>
            <input formControlName="Semat" type="text" class="form-control"  placeholder="Type here...">
            <small *ngIf="!get_Form_Semat().valid && get_Form_Semat().touched" class="form-text text-muted MyErrorRedColor">Enter the signatory position.</small>
          </div>
          <div class="form-group col-md-6">
            <label for="exampleInputEmail1">Signatory Name</label>
            <input formControlName="Name" type="text" class="form-control"  placeholder="Type here...">
            <small *ngIf="!get_Form_Name().valid && get_Form_Name().touched" class="form-text text-muted MyErrorRedColor">Enter the signatory name.</small>
          </div>
        </div>
        <div class="row">
          <div class="form-group col-md-6">
            <label for="exampleInputEmail1">Serial Code</label>
            <input formControlName="Code" type="text" class="form-control"  placeholder="Type here...">
            <small *ngIf="!get_Form_Code().valid && get_Form_Code().touched" class="form-text text-muted MyErrorRedColor">Enter the serial code.</small>
          </div>
        </div>
          <img *ngIf="InProccessing" src="assets/Loading.gif" style="width: 25px;" />
          <button *ngIf="!InProccessing" type="submit" [disabled]="!AddNewTextletter.valid" class="btn btn-success" style="margin-right: 5px;"><i class="fa  fa-plus-circle"></i> Save </button>
          <button *ngIf="!InProccessing" type="reset" class="btn btn-danger" style="margin-right: 5px;"><i class="fa fa-times-rectangle" ></i> Cancel </button>
          <button routerLink="/Textletter" *ngIf="!InProccessing" type="button" class="btn btn-warning"><i class="fa fa-mail-reply"></i> Back </button>
      </form>
  </div>
</div>
